import {API} from 'common/api';

// All guide-feedback endpoints live here so paths are easy to adjust.
// The key is the guide slug (interview_guides.slug) for both position and company guides.

export type GuideVote = 1 | 0 | -1;

export type GuideFeedbackReason =
  | 'incorrect'
  | 'outdated'
  | 'missing_explanation'
  | 'unclear'
  | 'typo'
  | 'other';

export async function getGuideVote(slug: string): Promise<GuideVote> {
  const vote = await API.get(`/v1/content-upvotes/guide/${encodeURIComponent(slug)}`);
  if (vote === 1 || vote === -1) return vote;
  return 0;
}

export async function postGuideVote(slug: string, vote: GuideVote): Promise<void> {
  await API.post(`/v1/content-upvotes/guides/${encodeURIComponent(slug)}`, {vote});
}

export async function postGuideFeedback({
  slug,
  reason,
  details,
}: {
  slug: string;
  reason: GuideFeedbackReason;
  details: string;
}): Promise<void> {
  const response = await API.post('/v1/content-feedback', {
    content_type: 'guide',
    content_uuid: slug,
    reason,
    details,
    page_url: window.location.href,
  });
  if (response instanceof Response && !response.ok) throw new Error('Feedback request failed');
}
